import buildLinkObj, { getRel } from '@repo/ui/src/functions/build-link';
import FormCheckbox from './form-checkbox';
import { classNames } from '@repo/ui/src/utils/classNames';
import type { LinkProps } from '@repo/ui/src/types/link';

interface FormAcknowledgementItem {
  title?: string;
  required?: boolean;
  display?: boolean;
  link?: LinkProps;
  disclaimer?: string;
  validationMessage?: string;
  helpText?: string;
  unique?: string;
}

interface FormAcknowledgementProps {
  item: FormAcknowledgementItem;
  unique: string;
  submitted: boolean;
  layout?: string;
  preCheck?: boolean;
}

const FormAcknowledgement = ({ item, unique, submitted, layout, preCheck }: FormAcknowledgementProps) => {
  const checkLink = item.link ? buildLinkObj(item.link) : null;
  const LinkItem = () => {
    return checkLink && checkLink.href !== 'link-not-set-amp' ? (
      <a rel={getRel(checkLink)} href={checkLink.href} className="underline">
        {item.link?.displayName}
      </a>
    ) : null;
  };
  return (
    <div>
      <div
        className={classNames(
          'relative py-3 mb-4 border border-transparent',
          layout !== 'One Column' && 'text-center',
        )}
        role="alert"
        aria-atomic="true"
      >
        {item.display ? (
          <FormCheckbox
            item={item}
            unique={item.unique ?? unique}
            key={unique}
            submitted={submitted}
            Link={LinkItem}
            preCheck={preCheck}
          />
        ) : (
          item.title
        )}
      </div>
    </div>
  );
};

export default FormAcknowledgement;
